import { Outlet } from 'react-router';

import { Navbar } from '@/widgets/layout';

import classes from './WorkspaceLayout.module.scss';
import {
  useActiveWorkspaceContext,
  Workspace,
} from '@/true-fsd/data/advertiser-account';
import {
  channelLinkMany,
  siteLinkMany,
} from '@/true-fsd/data/link/react-query/key-fn';
import { QueryFunction, usePrefetchQuery } from '@tanstack/react-query';

const getWorkspaceKeyFn = (ws: Workspace) => {
  if (ws.workspace_type === 'site') {
    return siteLinkMany({ site_id: ws.site_id });
  } else {
    return channelLinkMany({ channel_id: ws.channel_id });
  }
};

export const WorkspaceLayout = () => {
  const context = useActiveWorkspaceContext();
  // console.log({ context, component: 'WorkspaceLayout' })

  const opts = getWorkspaceKeyFn(context.activeWorkspace);
  usePrefetchQuery({
    queryKey: opts.queryKey,
    queryFn: opts.queryFn as QueryFunction,
  });

  return (
    <div className={classes.root}>
      <Navbar className={classes.side} />
      <div className={classes.content}>
        <Outlet context={context} />
      </div>
    </div>
  );
};
